module.exports = __webpack_public_path__ + "static/media/ic-delivery-location.4298e50c.svg";